/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import qs from 'query-string'

import Request from 'generic/request/Request'

export const SIMPLE_LANGUAGES_URL = '/api/simple/language/list/'
const LANGUAGE_URL = '/api/language/'
const LANGUAGES_URL = '/api/language/list/?meta=false&objects_count=false'

function getLanguages (query) {
  query = {
    ...query,
    page_size: 10
  }

  return Request.getRequest(LANGUAGES_URL + '&' + qs.stringify(query))
    .then((results) => {
      return results.data.objects.objects
    })
}

export function getLanguagesByLanguage (text) {
  const query = {
    search: 'language:' + text
  }

  return getLanguages(query)
}

export function getLanguagesByOrigin (text) {
  const query = {
    search: 'nationality:' + text
  }

  return getLanguages(query)
}

export const getLanguage = (uid) => {
  return Request.getRequest(LANGUAGE_URL + (uid ? uid + '/' : ''))
    .then((result) => {
      return result.data.object
    })
}



// WEBPACK FOOTER //
// ./src/actions/Language.js